import React, { useState, useEffect } from "react";
import { useDataProvider, useTranslate, Button } from "react-admin";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import CreatableSelect from "react-select/creatable";
import Typography from "@mui/material/Typography";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import styles from "./InvitationDialog.module.scss";

const InvitationDialog = (props) => {
	const translate = useTranslate();
	const dataProvider = useDataProvider();
	const [open, setOpen] = useState(props.openInvitationDialog);
	const [mails, setMails] = useState([]);
	const [role, setRole] = useState("editor");

	useEffect(() => {
		setOpen(props.openInvitationDialog);
	}, [props.openInvitationDialog]);

	const handleClose = () => {
		props.onClose();
		setOpen(false);
	};

	const sendInvitations = () => {
		dataProvider
			.createMany("application_invitations", {
				ids: mails.map((mail) => mail.trim().toLowerCase()),
				data: {
					role: role,
				},
			})
			.then(() => {
				props.onSendInvitation();
				setMails([]);
				setOpen(false);
			});
	};

	const components = {
		DropdownIndicator: null,
	};

	const handleChange = (value) => {
		const cleanedValues = value
			? value.map((e) => {
					return e.value.trim().toLowerCase();
				})
			: [];
		setMails(cleanedValues);
	};

	return (
		<Dialog
			onClose={handleClose}
			aria-labelledby="invitationDialog"
			open={open}
			maxWidth={"sm"}
			fullWidth
		>
			<DialogTitle>
				{translate("resources.application_members.invite_dialog_title")}
			</DialogTitle>
			<form className={styles.form}>
				<div className={styles.inputLabel}>
					{translate("pos.actions.send_to")}
				</div>
				<CreatableSelect
					className={styles.selectContainer}
					components={components}
					isMulti
					onChange={handleChange}
					placeholder="nom@domaine.fr"
					noOptionsMessage={() =>
						translate("pos.actions.invitation_email_placeholder")
					}
				/>
				<Typography
					variant="body1"
					component="span"
					className={styles.helperText}
				>
					<HelpOutlineIcon />{" "}
					{translate("resources.helpers.invitation_multi_select")}
				</Typography>
				<div className={styles.inputLabel}>
					{translate("pos.actions.invite_as")}
				</div>
				<FormControl variant="outlined" className={styles.selectInput}>
					<Select
						id="role_select"
						value={role}
						onChange={(event) => setRole(event.target.value)}
						fullWidth
						className={styles.select}
					>
						<MenuItem value={"admin"}>
							{translate("resources.application_members.admin")}
						</MenuItem>
						<MenuItem value={"editor"}>
							{translate("resources.application_members.editor")}
						</MenuItem>
						<MenuItem value={"moderator"}>
							{translate("resources.application_members.moderator")}
						</MenuItem>
					</Select>
				</FormControl>
			</form>
			<Button
				className={styles.inviteButton}
				alignIcon="left"
				label={
					translate("pos.actions.invite") +
					(mails.length > 0 ? ` (${mails.length})` : "")
				}
				onClick={() => sendInvitations()}
			/>
		</Dialog>
	);
};

export default InvitationDialog;
